import { Layout } from "@/components/Layout";
import { FAQ, LIBRARY_RESOURCES } from "@/data/library";
import { Barbell, ForkKnife, Pill, VideoCamera, CaretDown } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ICONS = { Barbell, ForkKnife, Pill, Video: VideoCamera };
const RESOURCE_LINKS = { exercises: "/ejercicios", supplementation: "/suplementacion", "nutrition-guide": "/guia-alimentacion" };

export default function Library() {
  return (
    <Layout>
      <section className="border-b border-as-border bg-as-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <p className="as-label text-as-green mb-3">MÓDULO 7 · BIBLIOTECA</p>
          <h1 className="as-heading text-5xl text-white">
            CONOCIMIENTO <span className="text-as-green">A LA MANO.</span>
          </h1>
        </div>
      </section>

      <section className="bg-as-surface py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="as-label text-as-green mb-6">RECURSOS</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {LIBRARY_RESOURCES.map((r) => {
              const Icon = ICONS[r.icon] || Barbell;
              const to = RESOURCE_LINKS[r.id];
              const inner = (
                <>
                  <Icon size={36} weight="duotone" color="#39FF14" className="mb-4" />
                  <h2 className="as-heading text-xl text-white mb-2">{r.title.toUpperCase()}</h2>
                  <p className="text-xs text-as-gray mb-4">{r.description}</p>
                  <span className="as-label text-as-green">{to ? "ABRIR →" : "PRÓXIMAMENTE"}</span>
                </>
              );
              return to ? (
                <Link to={to} key={r.id} className="as-card hover:border-as-green hover:-translate-y-1" data-testid={`resource-${r.id}`}>
                  {inner}
                </Link>
              ) : (
                <div key={r.id} className="as-card hover:border-as-green hover:-translate-y-1" data-testid={`resource-${r.id}`}>
                  {inner}
                </div>
              );
            })}
          </div>

          <p className="as-label text-as-green mb-6">PREGUNTAS FRECUENTES</p>
          <div className="as-card">
            <Accordion type="single" collapsible className="w-full">
              {FAQ.map((f) => (
                <AccordionItem key={f.q} value={f.q} className="border-b border-as-border last:border-0">
                  <AccordionTrigger className="text-white hover:text-as-green font-semibold text-left" data-testid={`faq-${f.q.slice(0, 20)}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-as-gray text-sm leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </Layout>
  );
}
